<template>
  <div class="earlyList">
    <div>
      <div class="title">
        租客企业预警
      </div>
      <div class="chart" v-if='map.length&&!loading'>
        <div class="item clearfix" v-for="(item,index) in map" :key='index' @click="check(item)">
          <div class="item-tit" :style='{background: index > 2 ? "#f0f2f5" : "#7A8799",color:index > 2 ? "#3a3a3a" : "#fff"}'>
            {{index + 1}}
          </div>
          <div class="first" :style="{color: index > 2 ? '#3a3a3a' : 'red'}">
            <el-tooltip :content="item.name" placement="top">
              <span>{{item.name}}</span>
            </el-tooltip>
          </div>
          <div class="two" :style="{color: index > 2 ? '#3a3a3a' : 'red'}">{{item.reason}}</div>
          <div class="three" :style="{color: index > 2 ? '#3a3a3a' : 'red'}">{{item.time}}</div>
        </div>
      </div>
      <!-- <div v-if="loading" class="demo-loading-container">
        <a-spin />
      </div>
      <div v-if="!map.length&&!loading" class="demo-loading-container">
        <a-empty />
      </div> -->
    </div>
  </div>
</template>

<script>
  import {lesseeGetWarnList} from '@/api/tenant.js'
  export default {
    name: "earlyList",
    components:{
    },
    data() {
      return {
        map: [],
        loading: false
      }
    },
    methods: {
      check(params){
        this.$router.push({path:'/tenantManagement/tenantDetail',query:{broadside:params.name,status:'1'}})
      },
      getMap() {
        this.loading = true
        lesseeGetWarnList({}).then(res => {
          let data = res.data
          if (data.code === '000') {
            this.map = data.content.list
          } else {
            this.map = []
          }
        }).catch(err => {
          console.log(err);
        }).finally(() => {
          this.loading = false
        })
      },
    },
    created() {
      this.getMap()
    }
  }
</script>

<style scoped lang="scss">
  .earlyList {
    width: 50%;
    min-height: 300px;
    background: #fff;
    box-sizing: border-box;
    padding-bottom: 2px;
    margin-right:30px;
    padding: 11px 14px;
    position:relative;
    .title {
      font-weight: 700;
      width: 600px;
      padding-left:24px;
      padding-top: 30px;
      color: #3B4859;
      font-size: 22px;
    }

    .chart {
      margin-top: 29px;
      padding-left:24px;
      .item {
        width: 100%;
        margin-top: 24px;
        margin-bottom: 18px;
        white-space: nowrap;
        color: #B8D7FF;
        overflow: hidden;
        .item-tit {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          font-size: 12px;
          color: #7A8799;
          line-height: 20px;
          text-align: center;
          background: #f0f2f5;
          overflow: hidden;
          float: left;
        }
        .first {
          width: 40%;
          margin-left: 20px;
          margin-right: 50px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          float: left;
        }
        .two{
          float: left;
          width: 120px;
          margin-right: 20px;
        }
        .three{
          float: right;
        }
        &:hover {
          cursor: pointer;
        }

      }
    }
    .demo-loading-container {
      padding:20px 0;
      text-align:center;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%,-50%);
    }
  }

</style>


